import { createFileRoute, redirect } from '@tanstack/react-router'
import { LIST, restoreFilters } from '@thom/folio-ui/routing/list-filters'
import { Logs } from '@thom/folio-ui/pages/logs'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/logs/')({
	beforeLoad: ({ search, cause, params, context }) => {
		if (cause !== 'enter') return
		const restored = restoreFilters(context.container.listMemory, LIST.LOGS, search)
		if (restored) throw redirect({ to: '/$client/$domain/$slug/logs', params, search: restored })
	},
	component: Logs,
})
